import { GUID } from "src/app/framework/domain-entity/guid";

export class Section {
  constructor(
    public name: string,
    public sectionId: GUID,
    public tabId: number
  ) {}
}
